import type { ReactNode } from 'react'
import React from 'react'

import { Icon } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './RemovableUpload.styled'

type Props = {
  children: ReactNode
  withBackground?: boolean
  onRemove(): void
}

export const RemovableUpload = ({ children, withBackground = true, onRemove }: Props) => (
  <S.Container withBackground={withBackground}>
    <S.Button type="button" onClick={onRemove}>
      <S.ButtonBackground />
      <Icon component={CloseIcon} height={12} />
    </S.Button>
    {children}
  </S.Container>
)
